var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"SingleCurveTable",attrs:{"row":"","fill-height":"","wrap":""}},[_c('ExportTableData',{ref:"pobierz",attrs:{"column-defs":_vm.columnDefs,"grid-options":_vm.gridOptions}}),_vm._v(" "),_c('ag-grid-vue',{staticClass:"ag-theme-balham",staticStyle:{"width":"100%","height":"90%"},attrs:{"gridOptions":_vm.gridOptions,"defaultColDef":_vm.defaultColDef,"stopEditingWhenGridLosesFocus":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5db4805c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewer/table/curves/SingleCurveTable.vue
// module id = 1864
// module chunks = 0